<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-right">
                <div class="search-name">汽配编码</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.APCode" placeholder="汽配编码"
                    :disabled="isOnly"></el-input>
                <div class="search-name">汽配名称</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.GoodName" placeholder="请输入汽配名称"
                    :disabled="isOnly"></el-input>
                <div class="search-name">仓库</div>
                <el-select v-model="searchData.WarehouseId" :loading="loading" class="search-item" size="small" filterable
                    clearable remote @visible-change="getWarehouse()" @change="warehouseChange($event)">
                    <el-option v-for="optionItem in WarehouseList" :label="optionItem.WarehouseName"
                        :value="optionItem.WarehouseId" v-bind:key="optionItem.index">
                        <span style="float: left">{{ optionItem.WarehouseName }}</span>
                        <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                    </el-option>
                </el-select>
                <div class="search-name">仓位</div>
                <el-select v-model="searchData.ShelfSpaceId" :loading="loading" class="search-item" filterable clearable
                    remote allow-create reserve-keyword :remote-method="searchPosition" size="small">
                    <el-option v-for="optionItem in positionList" :key="optionItem.ShelfSpaceId"
                        :label="optionItem.ShelfSpaceCode" :value="optionItem.ShelfSpaceId"></el-option>
                </el-select>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary"
                    @click="handleSearch">查询（Enter）</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="showSearchDialog">更多条件（F2）</el-button>
                <el-button size="small" icon="el-icon-printer" class="search-btn btn-primary"
                    v-if="permission.printIORecords" @click="print()">打印</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" border="" ref="multipleTable" :data="tableData"
                tooltip-effect="dark" style="width: 100%; cursor: pointer" highlight-current-row v-loading="tableLoading"
                @selection-change="handleSelectionChange" :row-key="getRowKeys">
                <el-table-column type="selection" reserve-selection width="50"></el-table-column>
                <el-table-column label="仓库" show-overflow-tooltip min-width="100px">
                    <template slot-scope="scope">
                        {{ (scope.row.WarehouseName ? scope.row.WarehouseName : '') + (scope.row.WarehouseCode ? ' / ' +
                            scope.row.WarehouseCode : '') }}
                        <span v-if="scope.row.WarehouseType == 1" style="color: #8492a6">(前置仓)</span>
                    </template>
                </el-table-column>
                <el-table-column label="仓位" show-overflow-tooltip min-width="100px">
                    <template slot-scope="scope">
                        {{
                            (scope.row.ShelfSpacesCode ? scope.row.ShelfSpacesCode : '') +
                            (scope.row.Type == 4 && scope.row.ToShelfSpacesCode ? ' ➡ ' + (scope.row.ToShelfSpacesCode ?
                                scope.row.ToShelfSpacesCode : '') : '')
                        }}
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="Code" label="出入仓相关单号" width="190px">
                    <template slot-scope="scope">
                        <el-tag @click="gotoDetails(scope.row)" v-if="scope.row.Code" class="codetag"
                            style="height: 11px; line-height:12px">{{ scope.row.Code }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="APCode" label="汽配编码" show-overflow-tooltip min-width="120px">
                    <template slot-scope="scope">
                        <img src="@/assets/images/deled.png" title="已删" style="width: 20px; height: 20px"
                            v-if="scope.row.State == 1" />
                        {{ scope.row.APCode }}
                    </template>
                </el-table-column>
                <el-table-column prop="GoodName" label="汽配名称" show-overflow-tooltip min-width="120px"></el-table-column>
                <el-table-column label="出入仓类型" show-overflow-tooltip min-width="120px" :render-header="renderHeader">
                    <template slot-scope="scope">
                        <div v-if="scope.row.Remark.length > 0">
                            <el-tooltip class="item" effect="dark" :content="scope.row.Remark" placement="top">
                                <el-tag size="small" type="success"
                                    v-if="scope.row.Type == 0 || scope.row.Type == 9 || scope.row.Type == 5 || scope.row.Type == 11 || scope.row.Type == 14 || scope.row.Type == 20 || scope.row.Type == 22 || scope.row.Type == 27">{{
                                        scope.row.StateName }}</el-tag>
                                <el-tag size="small" type="warning"
                                    v-if="scope.row.Type == 1 || scope.row.Type == 3 || scope.row.Type == 8 || scope.row.Type == 10 || scope.row.Type == 12">{{
                                        scope.row.StateName }}</el-tag>
                                <el-tag size="small" type="info"
                                    v-if="scope.row.Type == 4 || scope.row.Type == 7 || scope.row.Type == 16 || scope.row.Type == 17 || scope.row.Type == 18 || scope.row.Type == 19 || scope.row.Type == 23"
                                    effect="plain">{{ scope.row.StateName }}</el-tag>
                                <el-tag size="small" type="danger"
                                    v-if="scope.row.Type == 13 || scope.row.Type == 6 || scope.row.Type == 21 || scope.row.Type == 24 || scope.row.Type == 25">{{
                                        scope.row.StateName }}</el-tag>
                                <el-tag size="small"
                                    v-if="scope.row.Type == 15 || scope.row.Type == 2 || scope.row.Type == 26">{{
                                        scope.row.StateName }}</el-tag>
                            </el-tooltip>
                        </div>
                        <div v-else>
                            <el-tag size="small" type="success"
                                v-if="scope.row.Type == 0 || scope.row.Type == 9 || scope.row.Type == 5 || scope.row.Type == 11 || scope.row.Type == 14 || scope.row.Type == 20 || scope.row.Type == 22 || scope.row.Type == 27">{{
                                    scope.row.StateName }}</el-tag>
                            <el-tag size="small" type="warning"
                                v-if="scope.row.Type == 1 || scope.row.Type == 3 || scope.row.Type == 8 || scope.row.Type == 10 || scope.row.Type == 12">{{
                                    scope.row.StateName }}</el-tag>
                            <el-tag size="small" type="info"
                                v-if="scope.row.Type == 4 || scope.row.Type == 7 || scope.row.Type == 16 || scope.row.Type == 17 || scope.row.Type == 18 || scope.row.Type == 19 || scope.row.Type == 23"
                                effect="plain">{{ scope.row.StateName }}</el-tag>
                            <el-tag size="small" type="danger"
                                v-if="scope.row.Type == 13 || scope.row.Type == 6 || scope.row.Type == 21 || scope.row.Type == 24 || scope.row.Type == 25">{{
                                    scope.row.StateName }}</el-tag>
                            <el-tag size="small"
                                v-if="scope.row.Type == 15 || scope.row.Type == 2 || scope.row.Type == 26">{{
                                    scope.row.StateName }}</el-tag>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="100px" prop="OriginalCount" label="原总库数" show-overflow-tooltip></el-table-column>
                <el-table-column width="100px" prop="OriginalSSCount" label="原在仓数" show-overflow-tooltip>
                    <template slot-scope="scope">{{ !scope.row.WarehouseId ? '-' : scope.row.OriginalSSCount }}</template>
                </el-table-column>
                <el-table-column width="120px" label="出入仓数量" show-overflow-tooltip :render-header="renderHeader">
                    <template slot-scope="scope">
                        <i v-if="scope.row.Count > 0" class="inven-active">{{ scope.row.Count }}</i>
                        <i v-else class="cost-error">{{ scope.row.Count }}</i>
                    </template>
                </el-table-column>
                <el-table-column width="100px" label="剩余在仓数" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" v-if="scope.row.WarehouseId && scope.row.SCount > 0" :content="'原在库数：' + scope.row.SCount" placement="top">
                            <i>{{scope.row.LeftCount}}</i>
                        </el-tooltip>
                        <i v-else-if="scope.row.WarehouseId && scope.row.SCount == 0">{{ scope.row.LeftCount }}</i>
                        <i v-else>-</i>
                    </template>
                </el-table-column>
                <el-table-column width="160px" prop="FinishTime" label="出入仓时间" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Operator" label="操作人" show-overflow-tooltip width="80px"></el-table-column>
                <!-- <el-table-column prop="Remark" label="备注" show-overflow-tooltip min-width="100px"></el-table-column> -->
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="searchData.page" :page-sizes="[commonPageSize, 20, 30, 40, 50]" :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper" :total="tableDataLength"></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" title="出入库记录搜索" :visible.sync="dialogVisible" width="400px" append-to-body
            v-dialog-drag lock-scroll :modal="false" id="search-iologs-dialog" custom-class="search-item-dialog"
            style="margin-left: -170px">
            <div class="dialog-content" v-if="dialogVisible">
                <el-form ref="form" label-position="left" label-width="90px">
                    <el-form-item label="单据编号">
                        <el-input style="width: 100%" size="small" v-model.trim="searchData.Code"
                            v-filter-special-char="searchData.Code" placeholder="请输入出仓的单据编号"></el-input>
                    </el-form-item>
                    <el-form-item label="出入库类型">
                        <el-select class="search-item" size="small" v-model="searchData.Type" style="width: 100%"
                            @visible-change="typeVisibleChange($event)" clearable>
                            <el-option v-for="item in typeList" :key="item.TKey" :label="item.TValue"
                                :value="item.TKey"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="操作人">
                        <el-select style="width: 100%" v-model="searchData.SId" class="search-item" filterable clearable
                            remote size="small" placeholder="请选择" @visible-change="siVisibleChange($event)">
                            <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName"
                                :value="item.EmployeeId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="出入仓时间">
                        <el-date-picker size="small" style="width: 100%" v-model="dateTimes" type="daterange" align="right"
                            unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                            :picker-options="pickerOptions" @change="onDateTimeSelect"></el-date-picker>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="printdialogV" width="860px">
            <div class="dialog-content" v-if="printdialogV">
                <printInOutRecords @closeDialog="() => { printdialogV = false; }" :goodsList="multipleSelection"
                    :isInit="true">
                </printInOutRecords>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Vue from 'vue';
import mixin from '@/mixins/mixin';
import breadcrumb from '@/components/common/breadcrumb';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import printInOutRecords from '@/components/printModels/printInOutRecords';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        breadcrumb,
        printInOutRecords
    },
    data() {
        return {
            isStopReq: false,
            tableLoading: false,
            dialogVisible: false,
            dateTimes: [],
            isOnly: false,
            pageTitle: '查看记录',
            loading: false,
            tableData: [],
            searchData: {
                APId: '',
                APCode: '',
                GoodName: '',
                Type: '',
                SId: '',
                Code: '',
                WarehouseId: '',
                ShelfSpaceId: '',
                StartDate: '',
                EndDate: '',
                page: 1, // 当前页数
                limit: 15 // 每页限制条数
            },
            tableDataLength: 0,
            typeList: [],
            SIdList: [],
            WarehouseList: [],
            positionList: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            printdialogV: false,
            multipleSelection: [],
            permission: {}
        };
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
    },
    mounted() {
        let history_searchParams = this.$util.getLocalStorage('InOutRecords_searchParams');
        if (history_searchParams) {
            //判断查询参数是否有记录
            this.searchData = history_searchParams;
            this.$util.clearLocalStorage('InOutRecords_searchParams'); //用完即删
        }
        this.searchData.APId = this.$route.query.id;
        if (this.searchData.APId) {
            this.searchData.APCode = this.$route.query.code;
            this.searchData.GoodName = this.$route.query.name;
            this.isOnly = true; //这个的意思是在库存商品列表中直接进来的
        }
        this.permission = this.$util.getPermission('AutoPartsManage');
        this.getTableData();
    },
    methods: {
        handleKeyEvent(e) {
            let key = window.event.keyCode;
            let that = this;
            if (key === 113) {
                e.preventDefault();
                that.dialogVisible = true;
                return;
            }
            if (key === 27) {
                e.preventDefault();
                if (that.dialogVisible) that.dialogVisible = false;
                return;
            }
            if (key === 13) {
                e.preventDefault();
                that.handleSearch();
                return;
            }
            //右键
            if (key === 39) {
                e.preventDefault();
                if (!this.dialogVisible) {
                    let page = that.searchData.page;
                    let limit = that.searchData.limit;
                    let totalPages = Math.ceil(that.tableDataLength / limit);
                    if (page < totalPages) {
                        that.searchData.page += 1;
                        that.getTableData();
                    }
                }
                return;
            }
            //左键
            if (key === 37) {
                e.preventDefault();
                if (!that.dialogVisible) {
                    if (that.searchData.page !== 1) {
                        that.searchData.page -= 1;
                        that.getTableData();
                    }
                }
                return;
            }
        },
        renderHeader(h, { column }) {
            const dataContent = [
                h(
                    'div',
                    {
                        slot: 'content',
                        style: 'margin-bottom:5px'
                    },
                    '说明：'
                ),
                h(
                    'div',
                    {
                        slot: 'content'
                    },
                    '1、当出入仓类型为存放货物时，库存数量不产生变化，'
                ),
                h(
                    'div',
                    {
                        slot: 'content'
                    },
                    '产生变化的是对应的仓位存放对应货物的数量。'
                ),
                h(
                    'div',
                    {
                        slot: 'content'
                    },
                    '2、当出入仓类型为新增/编辑商品时，这里是库存数量的变化，不会出入库。'
                )
            ];
            const typeContent = [
                h(
                    'div',
                    {
                        slot: 'content'
                    },
                    '存放货物：'
                ),
                h(
                    'div',
                    {
                        slot: 'content'
                    },
                    '当没有任何的关联的出入仓单据时，库存变化的途径只有直接修改商品库存数量。'
                ),
                h(
                    'div',
                    {
                        slot: 'content'
                    },
                    '但，修改库存数量不能直接出仓，必须通过存放货物，存放到仓位中，才能出仓，'
                ),
                h(
                    'div',
                    {
                        slot: 'content'
                    },
                    '所以，存放货物，不会引起库存数量的变化，出入仓数量展示的是存放货物数量。'
                )
            ];
            return h('span', [
                h(
                    'el-tooltip',
                    {
                        props: {
                            placement: 'bottom'
                        }
                    },
                    [
                        column.label == '出入仓数量' ? dataContent : typeContent,
                        h('i', {
                            class: 'el-icon-warning-outline',
                            style: 'color:orange;margin-right:5px;'
                        })
                    ]
                ),
                h('span', column.label)
            ]);
        },
        getConfigData() {
            this.$util.getConfigData("InOutRecordType").then((res) => {
                this.typeList = res;
            });
        },
        typeVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList.length == 0) that.getConfigData();
            }
        },
        getSIdList() {
            this.$util.getSIdList(false).then(data => {
                this.SIdList = data;
            });
        },
        // 跳转到单据详情
        gotoDetails(row) {
            let searchParams = this.searchData;
            this.$util.setLocalStorage('InOutRecords_searchParams', searchParams); //保存当前查询参数，返回页面时使用

            if (row.Type == 0) {
                this.$router.push(`/purchaseManage/purchaseOrders/edit_v2?type=1&id=${row.BillId}`);
            } else if (row.Type == 1) {
                this.$router.push(`/salesManage/salesReturns/edit_v2?type=1&SReturnId=${row.BillId}`);
            } else if (row.Type == 2) {
                this.$router.push(`/salesManage/salesOrder/edit_v2?type=1&id=${row.BillId}`);
            } else if (row.Type == 3) {
                this.$router.push(`/purchaseManage/purchasesReturns/edit_v2?type=1&PReturnId=${row.BillId}`);
            } else if (row.Type == 4) {
                this.$router.push(`/inventoryManage/transSpaces/edit?type=1&TOId=${row.BillId}`);
            } else if (row.Type == 5 || row.Type == 6) {
                this.$router.push(`/inventoryManage/checkInventory/edit?type=1&InvensId=${row.BillId}`);
            } else if (row.Type == 10 || row.Type == 11) {
                this.$router.push(`/inventoryManage/transWarehouse/edit?type=1&TOId=${row.BillId}`);
            } else if (row.Type == 15) {
                this.$router.push(`/inventoryManage/goods/sets/setOrderEdit?type=1&SetOrderId=${row.BillId}`);
            }
        },
        resetSearch() {
            this.searchData = {
                APId: '',
                APCode: '',
                GoodName: '',
                Type: '',
                SId: '',
                Code: '',
                WarehouseId: '',
                ShelfSpaceId: '',
                StartDate: '',
                EndDate: '',
                page: 1, // 当前页数
                limit: this.commonPageSize // 每页限制条数
            };
            this.dateTimes = [];
            this.isOnly = false;
            this.$refs.multipleTable.clearSelection();
        },
        // 获取数据
        getTableData() {
            if (!this.isStopReq) {
                this.tableLoading = true;
                this.isStopReq = true;
                this.$util
                    .axiosGet({
                        url: '/api/EntpWarehouse/GetWHInOutRecords',
                        data: this.searchData,
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        if (!data) data = [];
                        this.tableData = data;
                        this.tableDataLength = res.count;
                    })
                    .catch(() => { })
                    .finally(() => {
                        this.tableLoading = false;
                        this.isStopReq = false;
                    });
            }
        },
        handleSearch() {
            this.$refs.multipleTable.clearSelection();
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 记录每行的key值
        getRowKeys(row) {
            return row.Id;
        },
        //当业务员下拉框出现时触发
        siVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.SIdList.length <= 1) that.getSIdList();
            }
        },
        // 仓库改变
        warehouseChange(value) {
            this.searchData.WarehouseId = value;
            this.searchPosition();
        },
        // 搜仓位
        searchPosition(key) {
            return new Promise(resolve => {
                this.$util
                    .axiosGet({
                        url: '/api/EntpShelfSpaces/GetEntpeGoodsLocationList',
                        data: {
                            WarehouseId: this.searchData.WarehouseId,
                            ShelfSpaceCode: key,
                            Limit: this.Limit
                        }
                    })
                    .then(res => {
                        if (res.data) {
                            this.positionList = res.data;
                        } else {
                            this.$util.warningMsg('该仓库暂无仓位');
                        }
                        resolve();
                    });
            });
        },
        // 获取仓库列表
        getWarehouse() {
            if (this.WarehouseList.length <= 1) {
                this.$util.getWarehouse(1).then(data => {
                    this.WarehouseList = data;
                });
            }
        },
        closeSearchDialog() {
            this.dialogVisible = false;
        },
        showSearchDialog() {
            this.dialogVisible = true;
        },
        onDateTimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        print() {
            if (!(this.multipleSelection && this.multipleSelection.length > 0)) {
                this.$util.warningMsg('请选择要打印的记录');
                return;
            }
            this.printdialogV = true;
        },
    }
};
</script>
<style lang="less" scoped>
.codetag {
    font-size: 14px;
    border-style: none none none none;
    background-color: transparent;
}
</style>
<style lang="less">
#search-iologs-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .search-item-dialog {
        width: 340px;
        height: auto;

        .dialog-footer {
            text-align: right;
        }

        .el-form-item {
            margin-bottom: 0;
        }
    }

    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}

</style>
